import { FormikForm } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'
import { withSuspense } from '@festina-life/ui/libs'
import * as Yup from 'yup'

import { AddBalancePostingFieldsPair } from './AddBalancePostingFieldsPair'
import type { SingletonBalancePostingPair } from './types'

type Props = {
  onSubmit: (values: SingletonBalancePostingPair) => void
  initialValues?: SingletonBalancePostingPair
  formId: string
}

const AddBalancePostingFormInternal = ({
  onSubmit,
  initialValues,
  formId,
}: Props) => {
  const translate = useTranslate()

  const VALIDATION_MESSAGES = {
    REQUIRED: translate('validation.required'),
  }

  const postingSchema = Yup.object({
    valueDate: Yup.string().required(VALIDATION_MESSAGES.REQUIRED),
    accountType: Yup.string().required(VALIDATION_MESSAGES.REQUIRED),
    postingType: Yup.string().required(VALIDATION_MESSAGES.REQUIRED),
    amount: Yup.number().required(VALIDATION_MESSAGES.REQUIRED),
  })

  const validationSchema = Yup.object({
    sender: postingSchema.clone(),
    receiver: postingSchema.clone().nullable(),
  })

  return (
    <FormikForm
      onSubmit={onSubmit}
      formId={formId}
      validationSchema={validationSchema}
      initialValues={
        initialValues ??
        ({
          sender: {
            _type: 'SingletonBalancePosting',
          },
          receiver: { _type: 'SingletonBalancePosting' },
        } satisfies SingletonBalancePostingPair as SingletonBalancePostingPair)
      }
    >
      {AddBalancePostingFieldsPair}
    </FormikForm>
  )
}

export const AddBalancePostingForm = withSuspense(AddBalancePostingFormInternal)
